import { TriggerReason } from '../models';
import { I18N_BASE } from '../constants';

export interface TriggerIconMeta {
  iconName: string;
  labelI18nKey: string;
  toneColorVar: string;
}

const META: Record<TriggerReason, TriggerIconMeta> = {
  created: {
    iconName: 'PlusCircle',
    labelI18nKey: `${I18N_BASE}.triggerReason.created`,
    toneColorVar: 'var(--gr-green)',
  },
  pageNameChanged: {
    iconName: 'Type01',
    labelI18nKey: `${I18N_BASE}.triggerReason.pageNameChanged`,
    toneColorVar: 'var(--gr-light-orange)',
  },
  pageBodyChanged: {
    iconName: 'FileEdit',
    labelI18nKey: `${I18N_BASE}.triggerReason.pageBodyChanged`,
    toneColorVar: 'var(--gr-light-orange)',
  },
  pageMainImageChanged: {
    iconName: 'Image01',
    labelI18nKey: `${I18N_BASE}.triggerReason.pageMainImageChanged`,
    toneColorVar: 'var(--gr-light-orange)',
  },
  pageAboutImageChanged: {
    iconName: 'Image03',
    labelI18nKey: `${I18N_BASE}.triggerReason.pageAboutImageChanged`,
    toneColorVar: 'var(--gr-light-orange)',
  },
  pageUrlChanged: {
    iconName: 'Link01',
    labelI18nKey: `${I18N_BASE}.triggerReason.pageUrlChanged`,
    toneColorVar: 'var(--gr-light-orange)',
  },
  pageTeamChanged: {
    iconName: 'Users01',
    labelI18nKey: `${I18N_BASE}.triggerReason.pageTeamChanged`,
    toneColorVar: 'var(--gr-light-orange)',
  },
  manual: {
    iconName: 'Hand',
    labelI18nKey: `${I18N_BASE}.triggerReason.manual`,
    toneColorVar: 'var(--gr-blue)',
  },
  rescore: {
    iconName: 'RefreshCw01',
    labelI18nKey: `${I18N_BASE}.triggerReason.rescore`,
    toneColorVar: 'var(--gr-blue)',
  },
  blobUploaded: {
    iconName: 'UploadCloud01',
    labelI18nKey: `${I18N_BASE}.triggerReason.blobUploaded`,
    toneColorVar: 'var(--gr-blue)',
  },
  multipleChanges: {
    iconName: 'LayersTwo01',
    labelI18nKey: `${I18N_BASE}.triggerReason.multipleChanges`,
    toneColorVar: 'var(--gr-orange)',
  },
};

const FALLBACK: TriggerIconMeta = {
  iconName: 'Flag06',
  labelI18nKey: `${I18N_BASE}.triggerReason.unknown`,
  toneColorVar: 'var(--text-muted)',
};

export function getTriggerIconMeta(reason: TriggerReason | null | undefined): TriggerIconMeta {
  if (!reason) return FALLBACK;
  return META[reason] ?? FALLBACK;
}
